import { download_file } from '../api/download'
import * as captcha from '../api/catpcha'
import { action } from '../utils/requests'

export default {
  name: 'FormLanding',
  data() {
    return {
      fields: {
        name: '',
        surname: '',
        company: '',
        phone: '',
        email: '',
      },
      captcha: '',
      captcha_image: '',
      captcha_error: false,
      success: false,
      submiting: false,
    }
  },
  mounted() {
    this.generateCaptcha()
  },
  methods: {
    submitForm() {
      if (this.submiting) {
        return
      }

      this.submiting = true

      this.validateCaptcha().then(success => {
        if (success) {
          action('save_form', {
            fields: this.fields,
            form: this.$refs['form-type'].value === 'download' ? 'form-download' : 'contact_form',
          }).then(() => {
            // Send email
            if (this.$refs['form-type'].value === 'download') {
              download_file(this.$refs['form-content-download'].value)
            } else {
              location.href = this.$refs['form-content-link'].value
            }

            this.resetForm()
            this.success = true
            this.submiting = false
          })
        } else {
          this.generateCaptcha()
          this.submiting = false
          this.captcha_error = true
        }
      })
    },

    validateCaptcha() {
      return captcha.validate(captcha.prefix(), this.captcha).then(res => res.status)
    },

    resetForm() {
      this.fields = {
        name: '',
        surname: '',
        company: '',
        phone: '',
        email: '',
      }
      this.success = false
      this.captcha_error = false
      this.generateCaptcha()
    },
    generateCaptcha() {
      this.captcha = ''
      captcha.create('#d9d9d9', '#00203d').then(res => {
        this.captcha_image = res.image
      })
    },
  },
}
